var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-simple-checkbox',{attrs:{"disabled":""},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})
}
var staticRenderFns = []

export { render, staticRenderFns }